function fallback() {
	return new Date().getTime()
}

export default Date.now || fallback
